<template>
  <div>
    <div class="space-y-16">
      <div class="text-static-default-hi heading-3">
        {{ i18n(translations.title) }}
      </div>
      <RevInfoBlock
        v-if="state === 'ON_HOLD'"
        :icon="IconWarning"
        :title="i18n(translations.paymentFailedInfo)"
        variant="danger"
      />
      <div v-if="dueAmount">
        <div class="text-static-default-hi body-2">
          {{ i18n(translations.totalDue) }}
        </div>
        <div class="text-static-default-hi punchline">
          {{ i18n.price(dueAmount) }}
        </div>
      </div>
      <div v-if="nextPayment">
        <div class="text-static-default-hi body-2">
          {{ i18n(translations.nextPayment) }}
        </div>
        <div class="flex items-baseline gap-4">
          <div class="text-static-default-hi heading-2">
            {{ i18n.price(nextPayment.price) }}
          </div>
          <div class="text-static-default-low body-2">
            {{
              i18n(translations.nextPaymentDate, {
                date: i18n.date(
                  new Date(nextPayment.date),
                  INSURANCE_DATE_FORMAT,
                ),
              })
            }}
          </div>
        </div>
      </div>
    </div>

    <RevButton
      v-if="state === 'ON_HOLD'"
      class="mt-16 md:mt-24"
      full-width="always"
      :to="{
        type: 'internal',
        name: INSURANCE.DUE_PAYMENT,
        params: {
          policyId,
        },
      }"
      :tracking="{
        zone: TRACKING_ZONES.POLICY_DETAILS,
        name: 'update-payment-method',
      }"
      variant="primary"
    >
      {{ i18n(translations.updatePaymentMethod) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api/src/api-models'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import {
  INSURANCE_DATE_FORMAT,
  TRACKING_ZONES,
} from '~/scopes/dashboard/services-hub/constant'
import type { PolicyDetails } from '~/scopes/dashboard/services-hub/types'
import { INSURANCE } from '~/scopes/insurance/routes.constants'

import translations from './PaymentDetails.translations'

const i18n = useI18n()

defineProps<{
  dueAmount: Price | null
  nextPayment: {
    date: string
    price: Price
  } | null
  state: PolicyDetails['policy']['state']
  policyId: string
}>()
</script>
